import styled from 'styled-components';

export const SimulateButtonWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
`;
